import { toSearchFailedError } from '../../Errors';
export const resolveSearchedReferences = search => query => search(query).catch(error => Promise.reject(toSearchFailedError(error)));